// REACT
import React, { useEffect, useState } from "react";

// REACT BOOTSTRAP
import { Col } from "react-bootstrap";

// REDUX
import { useDispatch, useSelector } from "react-redux";

// REACT ROUTER
import { useParams } from "react-router-dom";

// INTERNATIONALIZATION
import { FormattedMessage, useIntl } from "react-intl";

// STORE ACTIONS
import { editApplication } from "store/actions";

// COMPONENTS
import Form from "components/Form";
import FormWrapper from "components/Form/form-wrapper";
import Input from "components/Form/input";
import SaveChangesButton from "components/Form/save-changes-button";
import FormBuilder from "components/FormBuilder";
import ModalWrapperBtn from "components/shared/modal-wrapper-btn";
import { validateUrl } from "helpers/functions";

const AppSettings = () => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const { applicationId } = useParams();
    const { singleApplication } = useSelector((state) => state.applications);
    const [formObject, setFormObject] = useState({});
    useEffect(() => {
        setFormObject(singleApplication?.appSettings || {});
    }, [singleApplication]);
    let defaultValues = {
        appSettings: singleApplication?.appSettingsForm || {},
        appSettingsValidationUrl:
            singleApplication?.appSettingsValidationUrl || "",
    };

    const onSubmitSettings = (data) => {
        data.appSettings = formObject;

        dispatch(
            editApplication({
                endpointName: "settings",
                id: applicationId,
                data,
            })
        );
    };
    return (
        <FormWrapper>
            <Form onSubmit={onSubmitSettings} defaultValues={defaultValues}>
                <div className="settings-info">
                    <h5 className="side-title">
                        <FormattedMessage id="appSettings" />
                    </h5>
                    <Col xs="4" lg="2" md="3">
                        <ModalWrapperBtn
                            fullscreen
                            size="xl"
                            title={<FormattedMessage id="appSettings" />}
                            btnText={
                                <FormattedMessage
                                    id="builder"
                                    values={{
                                        str: (
                                            <FormattedMessage id="appSettings" />
                                        ),
                                    }}
                                />
                            }
                            btnClassName="bg-transparent border border-info text-info"
                            handleSave={() => console.log(formObject)}
                            modalClass="application-settings-modal"
                            closeBtn={false}
                        >
                            <FormBuilder
                                formObject={formObject}
                                setFormObject={setFormObject}
                            />
                        </ModalWrapperBtn>
                    </Col>
                </div>
                <Col xs="7">
                    <Input
                        type="url"
                        name="appSettingsValidationUrl"
                        langId={"appSettingsValidationUrl"}
                        lg="12"
                        rules={{
                            validate: (value) =>
                                validateUrl(value) ||
                                formatMessage({
                                    id: "invalidUrl",
                                }),
                        }}
                    />
                </Col>
                <SaveChangesButton />
            </Form>
        </FormWrapper>
    );
};

export default AppSettings;
